<template>
    <div>
        <div class="header-inner">
            <van-icon name="arrow-left" class="left-icon" @click="$router.push({ name: 'index' })" />
            <h2>历史提现榜</h2>
        </div>
        <div class="banner">
            <div class="historyCash-inner">
                <div class="cash-name" v-for="(item, i) in historyList" :key="i">
                    <p class="name">{{ item.rn_name }}</p>
                    <p class="amount">成功提现{{ item.amount }}元,总计提现{{ item.total_amount }}元</p>
                    <p class="ctime">{{ item.ctime }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                historyList: [],
            };
        },
        created() {

        },
        mounted() {
            this.getHistoryCash()
        },
        methods: {
            // 历史
            getHistoryCash() {
                this.$Ajax('user-cash/history-cash', {}, 'get').then(rs => {
                    if (rs.code == 200) {
                        this.historyList = rs.data.list.slice(0, 100)
                    }
                })
            },
        }
    };
</script>

<style scoped lang="less">
    .header-inner {
        position: fixed;
        top: 0;
        left: 50%;
        width: 100%;
        max-width: 525px;
        transform: translateX(-50%);
        text-align: center;
        overflow: hidden;
        display: flex;
        background: linear-gradient(33deg, #ff625a 0%, #df5f56 80%);
        height: 6rem;
        color: #fff;
        z-index: 100;

        h2 {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }

        .van-icon {
            position: absolute;
            left: 1rem;
            top: 50%;
            transform: translateY(-50%);
            font-size: 2rem;
            vertical-align: middle;
            cursor: pointer;
        }

    }

    .banner {
        margin-top: 6rem;

        .historyCash-inner {
            margin: 0 0.5rem;
            padding-top: 1rem;

            .cash-name {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 1.4rem 1rem;
                border-bottom: 1px solid #ddd;

                &:nth-last-child(1) {
                    border: none;
                }

                p {
                    color: #333;
                    font-size: 1.2rem;
                }
                .name {
                  width: 8rem;
                }
                .amount {
                  flex: 1;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
                .ctime {
                  width: 5rem;
                  text-align: end;
                }
            }
        }
    }
</style>